import React from 'react'
import { Card, CardActionArea, CardContent, Box, Typography, useTheme } from "@material-ui/core";

export function CardButton({ onClick, label, icon, disabled }: { disabled?: boolean, onClick: () => void, label: string, icon: React.ReactNode }) {
    const theme = useTheme()

    return (
        <>
            <Card style={{ backgroundColor: disabled ? theme.palette.background.default : theme.palette.primary.main, width: '100%' }}>
                <CardActionArea disabled={disabled} onClick={onClick}>
                    <CardContent>
                        <Box display="flex" alignItems="center" flexDirection="column" justifyContent="space-between">
                            {icon}
                            <Typography variant="body2" style={{ color: theme.palette.text.secondary }}>
                                {label}
                            </Typography>
                        </Box>
                    </CardContent>
                </CardActionArea>
            </Card>
        </>
    )
}
